import { Claim } from '@/modules/insurers/claims/types/Claim.ts'
import { appConfig } from '@/config/app.ts'

export interface ClaimState {
  isLoading: boolean
  claims: Claim[]
  filters: string
}

export const initialState: ClaimState = {
  isLoading: false,
  claims: [],
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
